import { reviewItems } from '@/mocks/cg51';
import SectionHeading from './SectionHeading';

export default function Reviews() {
  return (
    <section id="review" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <SectionHeading
          overline="复盘合集"
          title="每一次反转，都值得被重新讲一遍"
          note="事件尘埃落定之后，我们把全过程整理成带出处、带分歧的复盘。不同于快讯的即时，这里是慢下来看完整叙事的入口。"
        />

        <div className="grid grid-cols-1 gap-4 md:gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {reviewItems.map((item) => (
            <article
              key={item.title}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-colors hover:border-primary-200"
            >
              <div className="relative aspect-[3/2] w-full overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.alt}
                  title={`${item.title} · cg51复盘合集`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 inline-flex rounded-full bg-background-50/90 px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap text-primary-700 backdrop-blur">
                  {item.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <h3 className="font-heading text-base font-semibold leading-snug text-foreground-950 md:text-base">
                  {item.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200/70 pt-3.5">
                  <span className="text-xs whitespace-nowrap text-secondary-700">{item.phase}</span>
                  <a
                    href="#review"
                    className="inline-flex items-center gap-1 text-xs font-semibold whitespace-nowrap text-primary-700 hover:text-primary-600"
                  >
                    阅读复盘
                    <i className="ri-arrow-right-line text-sm" />
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}